// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__U5Vz5","row":"ProcedureTreatmentSummary_row__qjwSh"};